/**
 * Formats the asset name for use in a sentence.
 */
export const formatAssetName = (label: string | undefined) => {
  if (!label) return "Asset";
  return `${label}${label.toLowerCase().includes("asset") ? "" : " Asset"}`;
};
